import { render, staticRenderFns } from "./landslide.vue?vue&type=template&id=304f41c9&"
import script from "./landslide.vue?vue&type=script&lang=js&"
export * from "./landslide.vue?vue&type=script&lang=js&"
import style0 from "./landslide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('304f41c9', component.options)
    } else {
      api.reload('304f41c9', component.options)
    }
    module.hot.accept("./landslide.vue?vue&type=template&id=304f41c9&", function () {
      api.rerender('304f41c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/tra/landslide.vue"
export default component.exports